/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_7_TInputs */

const en_tut_part_7_t = /** @type {(inputs: Tut_Part_7_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings and billing`)
};

const id_tut_part_7_t = /** @type {(inputs: Tut_Part_7_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengatur dan membayar`)
};

/**
* | output |
* | --- |
* | "Settings and billing" |
*
* @param {Tut_Part_7_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_7_t = /** @type {((inputs?: Tut_Part_7_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_7_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_7_t(inputs)
	return en_tut_part_7_t(inputs)
});